import React, { useState } from 'react';

import MaterialTable from 'material-table'
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import CloseIcon from '@material-ui/icons/Close';



function TableGenerator({title,data,setData,typeTable,characters}) {
  var [errorText,setErrorText] = useState('Please enter a valid value');
  var columns
  if(typeTable===1)
{
columns = [
  //{ title: "Number", field: "id1", editable: false },
  { title: "Label", field: "value" },
  { title: "Color", field: "color", render: rowData => <input type="text" disabled style={{ backgroundColor:rowData.color }}/> , lookup: { '#FAEBD7':'Antique White','#00FFFF':'Aqua', '#7FFFD4':'Aqua Marine', '#F0FFFF':'Azure','#F5F5DC':'Beige','#0000FF':'Blue','#00008B':'Dark Blue','#A9A9A9':'Dark Grey','#8A2BE2':'Purple','#8B008B':'Dark Purple','#A52A2A':'Brown','#5F9EA0':'Cadet Blue','#D2691E':'Chocolate','#FF7F50':'Coral','#FF8C00':'Dark Orange','#228B22':'Forest Green','#008000':'Green','#90EE90':'Light Green','#FFD700':'Gold','#DAA520':'Golden Rod','#7FFF00':'Flashy Green' }, }
]
}
else if (typeTable===2){
  columns = [
    //{ title: "Number", field: "id1", editable: false },
    { title: "Time", field: "time", sortMethod: (a, b) => {
        return b-a;
    },editable: false},
    { title: "Alarm", field: "event",editable: false }
  ]
}
else
   columns = [
    //{ title: "Number", field: "id1", editable: false },
    { title: "Material Part Numbers", field: "pn" },
    { title: "Material Serial Number", field: "zid" }
  ]

  const [open, setOpen] = React.useState(false);
  return (
    <div className="App">
      <Box style={{ width: '50%' ,marginLeft:'auto',marginRight:'auto'}}>
      <Collapse in={open}>
        <Alert severity="error" 
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {errorText}
        </Alert>
      </Collapse>
     
    </Box>
      <MaterialTable
      style={{width:"100vh",alignContent:'center',alignItems:'center',textAlign:'center',display:'inline-block', borderRadius:5}}
        title={title}
        data={data}
        columns={columns}
        editable={{
          onRowAdd: (newRow) => new Promise((resolve, reject) => {
            
            if( typeTable===0 && typeof(newRow.pn)!=='undefined'&&typeof(newRow.zid)!=='undefined'){
              setTimeout(() => {
                const updatedRows = [...data, { id: Math.floor(Math.random() * 100), ...newRow }]
                setData(updatedRows)
                setOpen(false);
                resolve()
              }, 500)
            }
            else if( typeTable===1 && typeof(newRow.color)!=='undefined'&&typeof(newRow.value)!=='undefined'){
              setTimeout(() => {
                newRow.label=newRow.value
                const updatedRows = [...data, { id: Math.floor(Math.random() * 100), ...newRow }]
           
                
                setData(updatedRows)
                setOpen(false);
                resolve()
              }, 500)
            }

            else if( typeTable===2 && typeof(newRow.event)!=='undefined'&&typeof(newRow.time)!=='undefined'){
              setTimeout(() => {
                newRow.label=newRow.value
                var updatedRows = [...data, { id: Math.floor(Math.random() * 100), ...newRow }]
                updatedRows=updatedRows.sort(function(a,b){
                console.log(a.time+"<"+b.time+" "+a.time<b.time);
                return(a.time<b.time)
                })
                console.log(updatedRows)
                setData(updatedRows)
                setOpen(false);
                resolve()
              }, 500)
            }
            else {
              setTimeout(() => {
                reject();
              setOpen(true);
              }, 500)
          }
          }),

          onRowDelete: selectedRow => new Promise((resolve, reject) => {
            const index = selectedRow.tableData.id;
            const updatedRows = [...data]

            let x = -1;
            if (typeTable===1)
            x = characters.find(element => element.color === selectedRow.color);
            
            if(typeTable===2)
            {setTimeout(() => {
              reject();
              setErrorText('This data cannot be deleted or modified.')
            setOpen(true);
            }, 500)}

            else if(typeof(x)!=='undefined'&&x!==null&&typeTable===1)
            {setTimeout(() => {
              reject();
              setErrorText('This color is used for '+x.value+'. You need to delete this layer from the Vacuum Bag Configuration in order to delete this row. ')
            setOpen(true);
            }, 500)}
            else
            {setTimeout(() => {
              updatedRows.splice(index, 1)
              setData(updatedRows)
              setOpen(false);
              resolve()
            }, 500)}
          }),
          onRowUpdate:(updatedRow,oldRow)=>new Promise((resolve,reject)=>{
            const index=oldRow.tableData.id;
            const updatedRows=[...data]
            if(typeTable===1)
            updatedRow.field=updatedRow.value
            updatedRows[index]=updatedRow
            setTimeout(() => {
              setData(updatedRows)
              resolve()
            }, 500)
          })

        }}
        options={{
          actionsColumnIndex: -1, addRowPosition: "first", pageSizeOptions:[10,15,20], emptyRowsWhenPaging:false, pageSize:20
        }}
      />
    </div>
  );
}

export default TableGenerator;